var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsanaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5047 0.151855C21.6557 0.151855 25.0094 3.4997 25.0094 7.64354C25.0094 11.7874 21.6557 15.1352 17.5047 15.1352C13.3537 15.1352 10 11.7874 10 7.64354C10.0235 3.4997 13.3771 0.151855 17.5047 0.151855Z",
    fill: "url(#paint0_radial_957_315)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5047 16.8647C31.6557 16.8647 35.0094 20.2126 35.0094 24.3564C35.0094 28.5003 31.6557 31.8481 27.5047 31.8481C23.3537 31.8481 20 28.5003 20 24.3564C20.0235 20.2126 23.3771 16.8647 27.5047 16.8647Z",
    fill: "url(#paint1_radial_957_315)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50469 16.8647C11.6557 16.8647 15.0094 20.2126 15.0094 24.3564C15.0094 28.5003 11.6557 31.8481 7.50469 31.8481C3.35366 31.8481 0 28.5003 0 24.3564C0.0234522 20.2126 3.37711 16.8647 7.50469 16.8647Z",
    fill: "url(#paint2_radial_957_315)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_957_315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5136 7.63697) rotate(-90) scale(7.48871 7.50171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#F95353"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_957_315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5136 24.3499) rotate(-90) scale(7.48871 7.50171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#F95353"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_957_315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.51358 24.3499) rotate(-90) scale(7.48871 7.50171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#F95353"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsanaIcon);
export default __webpack_public_path__ + "static/media/asana-icon.429b09084e6ee3f40c87946faa359458.svg";
export { ForwardRef as ReactComponent };